import { Menu } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import type {
  GraphRendererApi,
  GraphEdgeDefinition,
} from '@/shared/ui/graph-renderer';
import IconArrowBarBoth from '@tabler/icons-react/dist/esm/icons/IconArrowBarBoth.mjs';
import IconArrowsSplit from '@tabler/icons-react/dist/esm/icons/IconArrowsSplit.mjs';

export const EdgeViewContextMenu = ({
  edge,
  api,
  close,
}: {
  edge: GraphEdgeDefinition;
  api: GraphRendererApi;
  close: () => void;
}) => {
  const { t } = useTranslation();

  const id = edge?.data?.id;

  return (
    <>
      <Menu.Label data-testid='edge-context-menu-label'>
        {edge?.data?.link?.label ||
          t('graphViews.text.compoundEdge', { ns: 'srm' })}
      </Menu.Label>
      {edge.data.type === 'compound' && (
        <>
          <Menu.Item
            data-testid='edge-context-menu-expand'
            onClick={() => {
              api.views?.expandEdges([id]);

              close();
            }}
            leftSection={<IconArrowsSplit />}
          >
            {t('graphViews.actions.expand', { ns: 'srm' })}
          </Menu.Item>
          <Menu.Item
            data-testid='edge-context-menu-expand-recursively'
            onClick={() => {
              api.views?.expandEdges([id], true);

              close();
            }}
            leftSection={<IconArrowBarBoth />}
          >
            {t('graphViews.actions.expandRecursively', { ns: 'srm' })}
          </Menu.Item>
        </>
      )}
    </>
  );
};
